import { PrizeTypeForm } from "./components";

export function CreatePrizeTypePage() {
  return (
    <div className="bg-white rounded-lg p-6 shadow-sm w-full">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Crear tipo de premiación</h2>
        <p className="text-gray-600 mt-1">
          Define un nuevo tipo de premiación para usar en pollas y torneos
        </p>
      </div>
      <PrizeTypeForm />
    </div>
  );
}
